import {
    SET_DATABASE_SELECTION,
    SET_DATABASE_DID_CHANGE
} from '../../actions';

const initialState = {
    database: null,
    didChange: false,
}

function databaseSelectorReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_DATABASE_SELECTION:
            newState.database = action.database;
            newState.didChange = state.didChange;
            return newState;

        case SET_DATABASE_DID_CHANGE:
            newState.database = state.database;
            newState.didChange = action.change;
            return newState;
        
        default:
            return state;

    }
}

export default databaseSelectorReducer;
